import { CountryDetailsService } from './api/CountryDetailsService'
import { CountryDetailsData } from './models/CountryDetailsModel'

const CountrryDetatilsModule = {
  namespaced: true,
  state: CountryDetailsData(),
  actions: {
    async countryDetails ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await CountryDetailsService.fetchCountryDetails(formData)
        const { data } = response
        if (data.length > 0) {
          resolve && resolve(data[0])
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}
export default CountrryDetatilsModule
